<script setup lang="ts">
defineProps<{
  // Set when the button's nearest positioning ancestor is flush with the
  // top of the viewport and iOS safe-area isn't handled by a wrapper above.
  // Example: Settings/Location fullscreen overlays in App.vue.
  needsSafeArea?: boolean
}>()
defineEmits<{ (e: 'click'): void }>()
</script>

<template>
  <v-btn
    icon
    class="app-close-btn"
    :class="{ 'app-close-btn--safe-area': needsSafeArea }"
    size="default"
    variant="text"
    @click="$emit('click')"
  >
    <v-icon size="default">mdi-close</v-icon>
  </v-btn>
</template>

<style scoped>
.app-close-btn {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  z-index: 1000 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: white !important;
  border-radius: 50% !important;
}

.app-close-btn--safe-area {
  top: max(var(--safe-area-top), 8px) !important;
}

.app-close-btn:hover {
  background-color: var(--surface-hover) !important;
}
</style>
